<template>
  <v-alert outlined text type="error" v-if="message">
    <div class="title">
      {{ message }}
    </div>
    <div v-for="(detail, key) in details" :key="key">
      {{ detail }}
    </div>
  </v-alert>
</template>
<script>
export default {
  name: "ApplicationErrorMessage",
  data: () => ({
    message: "",
    details: []
  }),

  watch: {
    $route: "initialize",
    errorObject: "initialize"
  },
  props: {
    errorObject: {
      type: Object,
      required: false,
      default: undefined
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      if (this.$route.params && this.$route.params.error) {
        const error = this.$route.params.error;
        this.setError(error);
      } else if (this.errorObject && this.errorObject.error) {
        const error = this.errorObject.error;
        this.setError(error);
      } else {
        this.message = "";
        this.details = [];
      }
    },
    setError(error) {
      this.message = "";
      this.details = [];
      if (error.message && error.message.value) {
        this.message = error.message.value;
      }
      if (error.innererror && error.innererror.errordetails) {
        error.innererror.errordetails.forEach(detail => {
          if (detail.message && detail.message.value) {
            this.details.push(detail.message.value);
          }
        });
      }
    }
  }
};
</script>
